import React from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Redirect,
    Route,
} from "react-router-dom";
import styled from "styled-components"
import {
    Container,
} from "reactstrap"
import Home from "./Home/Home"
import Trade from "./Trade/Trade"

const Wrapper = styled(Container)`
    margin-top: 20px;
`


const Routes = () => {



    return (
        <Wrapper>
            <Switch>
                <Route exact path="/">
                    <Home />
                </Route>
                <Route path="/trade">
                    <Trade />
                </Route>
                <Redirect to="/" />
            </Switch>
        </Wrapper>

    )
}

export default Routes